import { Right as a } from "../../constants/role.js";
import { useAccountContext as m } from "../account/AccountContext.js";
import { createStrictContext as f } from "../../util/context/createStrictContext.js";
import * as h from "ramda";
import { useCallback as c } from "react";
import { jsx as C } from "react/jsx-runtime";
const [R, v] = f("Role"), S = (s) => {
  const {
    children: i
  } = s, {
    account: e,
    isLoggedIn: t,
    setShowLoginPopup: r,
    setShowBindWalletPopup: n
  } = m(), o = c((u) => {
    const p = a[e.role];
    return h.propOr(!1, u, p);
  }, [e.role]), l = c(() => t ? o("operation") ? !0 : (n(!0), !1) : (r(!0), !1), [t, o, r, n]);
  return /* @__PURE__ */ C(R, {
    value: {
      checkRoleCanAccess: o,
      checkRoleCanOperate: l
    },
    children: i
  });
};
export {
  S as RoleProvider,
  v as useRoleContext
};
//# sourceMappingURL=RoleContext.js.map
